/**
 * @generated SignedSource<<9146405266777f32132822636a9539ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastScreenAdminQuery$variables = {
  screenId: string;
};
export type StorecastScreenAdminQuery$data = {
  readonly storecast: {
    readonly screen: {
      readonly id: string;
      readonly name: string;
      readonly showInfo: boolean;
      readonly " $fragmentSpreads": FragmentRefs<"StorecastScreenAdminContent_StorecastScreen">;
    };
  };
};
export type StorecastScreenAdminQuery = {
  response: StorecastScreenAdminQuery$data;
  variables: StorecastScreenAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "screenId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "screenId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showInfo",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastScreenAdminQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Storecast",
        "kind": "LinkedField",
        "name": "storecast",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "screen",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StorecastScreenAdminContent_StorecastScreen"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastScreenAdminQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Storecast",
        "kind": "LinkedField",
        "name": "storecast",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "screen",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Dashboard",
                "kind": "LinkedField",
                "name": "defaultDashboard",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inputMode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recommendedInputMode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StorecastDeviceSetDashboardScheduleItem",
                "kind": "LinkedField",
                "name": "scheduledStorecasts",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dashboard",
                    "kind": "LinkedField",
                    "name": "storecast",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weekdays",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StorecastDeviceInfo",
                "kind": "LinkedField",
                "name": "info",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "language",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "languageStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resolution",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resolutionStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "time",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeZone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeZoneStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userAgentStatus",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3d14556ee096f1449b03db12eecb6df6",
    "id": null,
    "metadata": {},
    "name": "StorecastScreenAdminQuery",
    "operationKind": "query",
    "text": "query StorecastScreenAdminQuery(\n  $screenId: ID!\n) {\n  storecast {\n    screen(id: $screenId) {\n      id\n      name\n      showInfo\n      ...StorecastScreenAdminContent_StorecastScreen\n    }\n  }\n}\n\nfragment InfoBox_StorecastScreen on StorecastScreen {\n  id\n  info {\n    language\n    languageStatus\n    resolution\n    resolutionStatus\n    time\n    timeStatus\n    timeZone\n    timeZoneStatus\n    userAgentStatus\n  }\n}\n\nfragment StorecastScreenAdminContent_StorecastScreen on StorecastScreen {\n  id\n  name\n  defaultDashboard {\n    id\n    name\n  }\n  ...StorecastScreenAdminModeSelector_StorecastScreen\n  ...StorecastScreenAdminSchedule_StorecastScreen\n  ...InfoBox_StorecastScreen\n}\n\nfragment StorecastScreenAdminModeSelector_StorecastScreen on StorecastScreen {\n  id\n  inputMode\n  recommendedInputMode\n}\n\nfragment StorecastScreenAdminSchedule_StorecastScreen on StorecastScreen {\n  id\n  scheduledStorecasts {\n    id\n    storecast {\n      id\n      name\n    }\n    startAt\n    endAt\n    weekdays\n  }\n}\n"
  }
};
})();

(node as any).hash = "052ec4a589f64dd9739644722c3b6b86";

export default node;
